module.exports = {"id":"dp2_6l3q1","text":"Managing Digital Identity","instructions":"Which best describes the relationship between digital identity and digital reputation?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.6","questionType":"PickOne","random":true,"options":[{"id":"dp2_6l3q1-a1","text":"Reputation forms from identity activity","score":3.7},{"id":"dp2_6l3q1-a2","text":"Reputation replaces digital identity","score":1.3},{"id":"dp2_6l3q1-a3","text":"Identity only exists offline","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.6/l3q1.json
// module id = 1095
// module chunks = 41